import React from 'react';
import { DomainTypeShare } from '../../types';
import { HighlightBarChart } from './HighlightBarChart';
import { useI18n } from '../../i18n/useI18n';

interface DomainTypesChartProps {
  data: DomainTypeShare[];
  className?: string;
}

const typeColors: Record<DomainTypeShare['type'], string> = {
  Corporate: '#f97316',
  Reference: '#a855f7',
  Editorial: '#3b82f6',
  UGC: '#06b6d4',
  Other: '#94a3b8',
  Institutional: '#84cc16',
  Competitor: '#f43f5e',
};

export const DomainTypesChart: React.FC<DomainTypesChartProps> = ({ data, className = '' }) => {
  const { t } = useI18n();

  return (
    <HighlightBarChart
      className={className}
      items={data.map((item) => {
        const translatedLabel = t('pages.' + item.type.toLowerCase());
        return {
          label: translatedLabel !== 'pages.' + item.type.toLowerCase() ? translatedLabel : item.type,
          value: item.share,
          dotColor: typeColors[item.type],
          valueLabel: `${item.share}%`,
        };
      })}
      adaptiveRowSpacing
      barColor="bg-zinc-400/50"
    />
  );
};
